import React, { useState } from 'react';
import { motion } from 'framer-motion';
import EsteticaModal from './EsteticaModal';

// Fondo fijo con imagen optimizada - Componente compartido
const FixedBackground = () => (
  <div className="fixed inset-0 -z-10 overflow-hidden">
    <div 
      className="absolute inset-0 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')",
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-crema/90 via-crema/95 to-crema/20"></div>
    </div>
    
    <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-b from-green-50/20 to-transparent hidden md:block"></div>
    <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-t from-teal-50/20 to-transparent hidden md:block"></div>

    <div className="absolute inset-0 opacity-3 md:opacity-5 mix-blend-overlay">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <pattern 
          id="pattern" 
          x="0" 
          y="0" 
          width="60" 
          height="60" 
          patternUnits="userSpaceOnUse"
          patternTransform="rotate(15)"
        >
          <circle cx="30" cy="30" r="1" fill="#869370" opacity="0.4" />
          <circle cx="45" cy="45" r="0.8" fill="#6a7556" opacity="0.3" />
        </pattern>
        <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern)" />
      </svg>
    </div>
    
    <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPjxkZWZzPjxmaWx0ZXIgaWQ9Im5vaXNlIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iMC43IiBudW1PY3RhdmVzPSIzIiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PC9maWx0ZXI+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbHRlcj0idXJsKCNub2lzZSkiIGOPY2l0eT0iMC4wMiIvPjwvc3ZnPg==')] 
      mix-blend-overlay pointer-events-none opacity-50 md:opacity-100"></div>
  </div>
);

// Iconos con estilo verde
const DurationIcon = () => (
  <svg className="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);

const DressCodeIcon = () => (
  <svg className="w-5 h-5 mr-2 text-green-600" fill="none" stroke="currentColor" strokeWidth="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
  </svg>
);

// Imágenes de tratamientos faciales
const treatmentImages = {
  limpieza: 'https://makeup-express.cl/wp-content/uploads/2019/04/limpieza-facial.jpg',
  limpiezaprofunda: 'https://i.imgur.com/iyD3ePN.jpeg',
  premium: 'https://emociom.com/img/ofertas/Principal/2023/11/2/13128_2023_nov_07_13_21_01.jpg',
  glow: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  hilos: 'https://clinicaciudamar.com/wp-content/uploads/2022/05/hilos-tensores.jpeg',
  labios: 'https://clinicajaimevilar.es/wp-content/uploads/2025/04/2.webp',
  botoxcosmiatrico: 'https://i.imgur.com/UIQmmIS.jpeg', 
  laserneatcell: 'https://i.imgur.com/EMj4Mfn.jpeg', 
  extraccion: 'https://i.imgur.com/RAqy5pq.png', 
  dermapen1: 'https://i.imgur.com/MtKUE3e.jpeg', 
  peeling: 'https://images.unsplash.com/photo-1512290900676-26c2a5a095ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80'
};

function EsteticaFaciales() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ 
    title: '', 
    description: '', 
    imageUrl: '', 
    duration: '', 
    dressCode: '', 
    benefits: [] 
  });

  const openModal = (title, description, imageKey, duration, dressCode, benefits) => {
    setModalContent({ 
      title: title || 'Tratamiento', 
      description: description || 'Descripción del tratamiento', 
      imageUrl: treatmentImages[imageKey] || treatmentImages.limpieza || 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
      duration: duration || 'Consultar', 
      dressCode: dressCode || 'Ropa cómoda', 
      benefits: benefits || ['Beneficios del tratamiento'] 
    });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  // Limpiezas faciales principales de la imagen oficial
  const limpiezasPrincipales = [
    {
      title: "LIMPIEZA FACIAL EXPRÉS",
      price: "Gs. 90.000",
      description: "Tratamiento facial rápido e intensivo ideal para mantener el rostro libre de impurezas superficiales e hidratado.",
      imageKey: "limpieza",
      duration: "35 a 45 minutos",
      dressCode: "Ropa cómoda",
      includes: [
        "Limpieza",
        "Exfoliación",
        "Tónico",
        "Mascarilla según necesidad de la piel",
        "Hidratación",
        "Protector solar"
      ]
    },
    {
      title: "LIMPIEZA FACIAL PROFUNDA",
      price: "Gs. 180.000",
      description: "Procedimiento cosmetológico completo que elimina la suciedad celular profunda, comedones y puntos negros mediante aparatología de última generación.",
      imageKey: "limpiezaprofunda",
      duration: "60 a 75 minutos",
      dressCode: "Ropa cómoda",
      includes: [
        "Limpieza y exfoliación",
        "Tónico",
        "Mascarillas según necesidad",
        "Punta de diamante",
        "Espátula ultrasónica",
        "Extracción de puntos negros e impurezas",
        "Descongestión",
        "Alta frecuencia",
        "Hidratación y humectación",
        "Hidratación de labios",
        "Protector solar"
      ]
    }
  ];

  // Tratamientos Plus de la lista de precios oficial
  const tratamientosPlusFacial = [
    {
      name: "Limpieza facial + Dermapen",
      price: "Gs. 220.000",
      subtitle: "",
      description: "Combina la desobstrucción e higiene de poros con micro-agujas (Dermapen) para estimular colágeno, atenuar líneas y poros dilatados.",
      imageKey: "dermapen1",
      duration: "60 a 75 minutos",
      dressCode: "Ropa cómoda",
      benefits: [
        "Inducción profunda de colágeno y elastina",
        "Piel renovada y rejuvenecida",
        "Disminuye poros y textura irregular",
        "Higiene profunda garantizada"
      ]
    },
    {
      name: "Peelings químicos",
      price: "Gs. 250.000",
      subtitle: "(Dependiendo del tratamiento)",
      description: "Renovación epidérmica mediante ácidos dermatológicos seleccionados según las necesidades cutáneas (hiperpigmentación, acné o rejuvenecimiento).",
      imageKey: "peeling",
      duration: "45 a 60 minutos",
      dressCode: "Ropa cómoda",
      benefits: [
        "Eliminación de células muertas profundas",
        "Disminución de manchas y melasma",
        "Mejora radical del tono y luminosidad",
        "Tratamiento adaptado al tipo de piel"
      ]
    }
  ];

  // Tratamientos especializados adicionales
  const otrosTratamientosFaciales = [
    { 
      name: "Bby glow", 
      price: "Gs. 220.000", 
      description: "Tratamiento efecto piel de porcelana que aporta luminosidad y atenúa imperfecciones con principios activos vitaminados.", 
      imageKey: "glow", 
      duration: "60 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Unifica el tono de piel", "Efecto base natural duradero", "Hidratación intensa"] 
    },
    { 
      name: "Hilos tensores con electroporador", 
      price: "Gs. 240.000", 
      description: "Técnica sin agujas que introduce hilos colágenos mediante corriente para reafirmar y tensionar zonas del rostro.", 
      imageKey: "hilos", 
      duration: "75 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Efecto lifting sin agujas", "Reafirma el óvalo facial", "Sin molestias"] 
    },
    { 
      name: "Hidratación de labios", 
      price: "Gs. 180.000", 
      description: "Cuidado labial intensivo que exfolia, nutre y rellena sutilmente con ácido hialurónico tópico.", 
      imageKey: "labios", 
      duration: "45 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Labios suaves y humectados", "Disminuye líneas verticales", "Efecto jugoso natural"] 
    },
    { 
      name: "Botox Cosmiátrico", 
      price: "Gs. 200.000", 
      description: "Aplicación cosmetológica orientada a relajar líneas de expresión y devolver frescura al rostro.", 
      imageKey: "botoxcosmiatrico", 
      duration: "60 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Suaviza líneas de expresión", "Previene envejecimiento", "Aspecto descansado"] 
    },
    { 
      name: "Láser Neatcell Facial", 
      price: "Gs. 150.000", 
      description: "Pulsos de luz picosegundos para rejuvenecimiento facial, tratamiento de manchas y cicatrices de acné.", 
      imageKey: "laserneatcell", 
      duration: "45-60 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Despigmentante eficaz", "Estímulo celular de colágeno", "Rejuvenecimiento cutáneo"] 
    },
    { 
      name: "Láser Neatcell por Zona", 
      price: "Gs. 160.000", 
      description: "Aplicación puntual con tecnología láser para tratar manchas o marcas en áreas específicas del rostro.", 
      imageKey: "laserneatcell", 
      duration: "30-45 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Tratamiento localizado preciso", "Atenúa pigmentaciones", "Mejora textura específica"] 
    },
    { 
      name: "Extracción de Puntos Negros y Espinillas", 
      price: "Gs. 80.000", 
      description: "Sesión focalizada en desobstruir comedones e impurezas persistentes sin agredir el tejido.", 
      imageKey: "extraccion", 
      duration: "35 a 45 minutos", 
      dressCode: "Ropa cómoda", 
      benefits: ["Piel descongestionada", "Previene brotes", "Poros limpios"] 
    }
  ];

  return (
    <div className="relative">
      <div className="relative z-10">
        <FixedBackground />
        <motion.section 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="min-h-screen relative overflow-hidden py-20 pt-32"
        >
          <div className="container mx-auto px-4 relative z-10">
            {/* Header oficial de Valoración de la Piel */}
            <motion.div
              initial={{ y: -20 }}
              animate={{ y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center mb-12"
            >
              <div className="inline-block px-4 py-1.5 rounded-full bg-green-100/80 text-green-800 text-sm font-semibold mb-3 shadow-sm border border-green-200">
                Tu piel, mi prioridad ♡
              </div>
              
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-green-700 mb-4 font-serif">
                Valoración de la Piel
              </h2>
              
              <p className="text-base md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed font-light mb-3">
                Identificamos tu biotipo cutáneo y fototipo para conocer las características y necesidades de tu piel.
              </p>
              
              <p className="text-sm md:text-base text-green-800 font-medium max-w-2xl mx-auto">
                A partir de esta valoración, seleccionamos el tratamiento y las técnicas que mejor se adapten a vos y a tus objetivos.
              </p>

              <div className="mt-6 flex justify-center">
                <div className="w-28 h-1 bg-gradient-to-r from-green-400 via-teal-400 to-emerald-400 rounded-full"></div>
              </div>
            </motion.div>

            {/* Abordamos diferentes necesidades de la piel */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
              className="bg-white/80 backdrop-blur-md rounded-3xl p-6 md:p-8 shadow-md border border-green-200/80 max-w-4xl mx-auto mb-16"
            >
              <h3 className="text-xl md:text-2xl font-bold text-green-900 font-serif text-center mb-2">
                Abordamos diferentes necesidades de la piel
              </h3>
              <p className="text-sm md:text-base text-gray-600 text-center mb-6">
                Trabajamos tratamientos estéticos orientados al cuidado y mejora de:
              </p>

              <div className="flex flex-wrap justify-center gap-2.5 mb-6">
                {[
                  'Piel sensible y deshidratada',
                  'Signos de envejecimiento cutáneo',
                  'Líneas de expresión y arrugas',
                  'Hiperpigmentación y manchas',
                  'Marcas y cicatrices superficiales',
                  'Seborrea y alteraciones de la apariencia de la piel',
                  'Daño y fotoenvejecimiento producido por la exposición solar'
                ].map((item, index) => (
                  <span 
                    key={index}
                    className="px-4 py-2 bg-gradient-to-r from-green-50 to-emerald-50 text-green-800 rounded-full text-xs md:text-sm font-semibold border border-green-200/60 shadow-sm"
                  >
                    ✦ {item}
                  </span>
                ))}
              </div>

              <p className="text-xs md:text-sm text-gray-500 italic text-center leading-relaxed border-t border-green-100 pt-4">
                Cada caso se valora previamente para determinar el abordaje estético más adecuado. Cuando una condición requiere evaluación o tratamiento médico, se recomienda la consulta con un profesional de dermatología.
              </p>
            </motion.div>

            {/* SECCIÓN 1: LIMPIEZAS FACIALES DESTACADAS (TARJETAS CON INCLUYE) */}
            <div className="mb-16">
              <div className="flex items-center space-x-3 mb-8">
                <span className="bg-green-100 text-green-700 p-2.5 rounded-xl">
                  <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </span>
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-green-900 font-serif">
                    FACIALES PRINCIPALES
                  </h3>
                  <p className="text-sm text-gray-600">Higiene y restauración cutánea personalizada</p>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {limpiezasPrincipales.map((facial, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.1, duration: 0.5 }}
                    whileHover={{ y: -6 }}
                    className="bg-white/70 backdrop-blur-md rounded-3xl shadow-lg border border-green-200/60 overflow-hidden hover:shadow-2xl transition-all flex flex-col justify-between"
                  >
                    <div className="p-8">
                      <div className="flex flex-col sm:flex-row sm:items-center justify-between pb-6 border-b border-green-100 gap-4">
                        <div>
                          <span className="text-xs font-bold text-green-700 uppercase tracking-widest bg-green-100/80 px-3 py-1 rounded-full">
                            Protocolo Esencial
                          </span>
                          <h4 className="text-2xl font-bold text-gray-800 font-serif mt-2">
                            {facial.title}
                          </h4>
                        </div>
                        <div className="bg-gradient-to-r from-green-700 to-emerald-600 text-white font-bold text-xl px-5 py-2 rounded-2xl shadow-sm self-start sm:self-auto">
                          {facial.price}
                        </div>
                      </div>

                      <p className="text-gray-600 my-4 text-sm leading-relaxed">
                        {facial.description}
                      </p>

                      <div className="mt-6 bg-green-50/60 rounded-2xl p-5 border border-green-100">
                        <h5 className="text-sm font-bold text-green-800 uppercase tracking-wider mb-3 flex items-center">
                          <svg className="w-4 h-4 mr-2 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          Incluye:
                        </h5>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                          {facial.includes.map((inc, iIdx) => (
                            <li key={iIdx} className="flex items-center text-sm text-gray-700 font-medium">
                              <span className="w-2 h-2 rounded-full bg-green-500 mr-2 flex-shrink-0"></span>
                              <span>{inc}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="px-8 pb-8 pt-0">
                      <button
                        onClick={() => openModal(facial.title, facial.description, facial.imageKey, facial.duration, facial.dressCode, facial.includes)}
                        className="w-full py-3 px-6 bg-green-600 hover:bg-green-700 text-white rounded-xl text-sm font-semibold transition-all duration-300 shadow-md hover:shadow-lg flex items-center justify-center space-x-2"
                      >
                        <span>Ver detalles del tratamiento</span>
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* SECCIÓN 2: TRATAMIENTOS PLUS FACIAL */}
            <div className="mb-16">
              <div className="p-6 rounded-2xl bg-gradient-to-r from-emerald-900/90 to-teal-800/90 text-white shadow-md border border-emerald-700/50 mb-8 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div className="flex items-center space-x-3">
                  <span className="bg-white/20 text-emerald-200 p-2.5 rounded-xl">
                    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M5 21v-4M3 19h4m10-16v4m2-2h-4m4 14v-4m2 2h-4M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </span>
                  <div>
                    <h3 className="text-2xl md:text-3xl font-bold font-serif text-white">
                      TRATAMIENTOS PLUS
                    </h3>
                    <p className="text-sm text-emerald-100">Potenciación dermatológica y regeneración profunda</p>
                  </div>
                </div>
                <span className="bg-amber-400 text-gray-900 text-xs font-bold uppercase px-3 py-1 rounded-full self-start sm:self-auto">
                  Técnicas Avanzadas
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {tratamientosPlusFacial.map((item, itemIndex) => (
                  <motion.div
                    key={itemIndex}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: itemIndex * 0.1, duration: 0.4 }}
                    whileHover={{ y: -5 }}
                    className="bg-white/70 backdrop-blur-md rounded-2xl shadow-md border border-white/60 p-6 flex flex-col justify-between hover:shadow-xl transition-all"
                  >
                    <div>
                      <div className="flex justify-between items-start mb-3 gap-2">
                        <div>
                          <h4 className="text-xl font-bold text-gray-800">
                            {item.name}
                          </h4>
                          {item.subtitle && (
                            <span className="text-xs text-gray-500 italic block mt-0.5">
                              {item.subtitle}
                            </span>
                          )}
                        </div>
                        <span className="bg-gradient-to-r from-green-700 to-emerald-600 text-white font-bold px-4 py-1.5 rounded-full text-base whitespace-nowrap shadow-sm">
                          {item.price}
                        </span>
                      </div>
                      <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                        {item.description}
                      </p>
                    </div>

                    <button
                      onClick={() => openModal(item.name, item.description, item.imageKey, item.duration, item.dressCode, item.benefits)}
                      className="w-full py-2.5 px-4 bg-green-50 hover:bg-green-600 text-green-700 hover:text-white rounded-xl text-sm font-semibold transition-all duration-300 flex items-center justify-center space-x-2 border border-green-200/60 shadow-sm"
                    >
                      <span>Ver más información</span>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* SECCIÓN 3: OTROS TRATAMIENTOS FACIALES Y APARATOLOGÍA */}
            <div className="mb-16">
              <h3 className="text-2xl font-bold text-green-900 font-serif mb-6 flex items-center space-x-2">
                <span>Especialidades y Aparatología Facial</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {otrosTratamientosFaciales.map((item, itemIndex) => (
                  <motion.div
                    key={itemIndex}
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: itemIndex * 0.05, duration: 0.4 }}
                    whileHover={{ y: -5 }}
                    className="bg-white/60 backdrop-blur-md rounded-2xl shadow-sm border border-white/60 p-6 flex flex-col justify-between hover:shadow-lg transition-all"
                  >
                    <div>
                      <div className="flex justify-between items-start mb-2 gap-2">
                        <h4 className="text-base font-bold text-gray-800">
                          {item.name}
                        </h4>
                        <span className="text-green-700 font-bold bg-green-100/60 px-3 py-1 rounded-full text-sm whitespace-nowrap border border-green-200/40">
                          {item.price}
                        </span>
                      </div>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                        {item.description}
                      </p>
                    </div>

                    <button
                      onClick={() => openModal(item.name, item.description, item.imageKey, item.duration, item.dressCode, item.benefits)}
                      className="text-xs text-green-700 font-bold hover:underline flex items-center space-x-1"
                    >
                      <span>Más detalles</span>
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                      </svg>
                    </button>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* SECCIÓN DESTACADA DE GARANTÍA Y CALIDAD (COMO EL FOOTER DEL FLYER) */}
            <div className="bg-white/80 backdrop-blur-md rounded-3xl p-8 border border-green-200/80 shadow-md">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-center">
                <div className="p-3">
                  <div className="w-12 h-12 bg-green-100 text-green-700 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-inner">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                    </svg>
                  </div>
                  <h5 className="font-bold text-gray-800 text-sm uppercase tracking-wide">Productos de alta calidad</h5>
                </div>

                <div className="p-3">
                  <div className="w-12 h-12 bg-teal-100 text-teal-700 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-inner">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                  <h5 className="font-bold text-gray-800 text-sm uppercase tracking-wide">Tratamientos personalizados</h5>
                </div>

                <div className="p-3 col-span-2 md:col-span-1">
                  <div className="w-12 h-12 bg-green-100 text-green-700 rounded-2xl flex items-center justify-center mx-auto mb-3 shadow-inner">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h5 className="font-bold text-gray-800 text-sm uppercase tracking-wide">Turnos Previos ¡Escribinos!</h5>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-green-100 text-center font-serif text-green-800 text-lg font-bold">
                CLEO ESTÉTICA ♡
              </div>
            </div>
          </div>
        </motion.section>

        <EsteticaModal
          isOpen={isModalOpen}
          onClose={closeModal}
          title={modalContent.title}
          content={modalContent.description}
          imageUrl={modalContent.imageUrl}
          duration={modalContent.duration}
          dressCode={modalContent.dressCode}
          benefits={modalContent.benefits}
          DurationIcon={DurationIcon}
          DressCodeIcon={DressCodeIcon}
        />
      </div>
    </div>
  );
}

export default EsteticaFaciales;
